"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaypalGatewayPublicId = exports.setPaypalGatewayPublicId = exports.hasPaypalNameSpace = exports.getPaypalNameSpace = exports.setPaypalNameSpace = void 0;
const src_1 = require("..");
function setPaypalNameSpace(paypal) {
    src_1.paypalState.paypal = paypal;
}
exports.setPaypalNameSpace = setPaypalNameSpace;
function getPaypalNameSpace() {
    return src_1.paypalState.paypal;
}
exports.getPaypalNameSpace = getPaypalNameSpace;
function hasPaypalNameSpace() {
    return !!src_1.paypalState.paypal;
}
exports.hasPaypalNameSpace = hasPaypalNameSpace;
function setPaypalGatewayPublicId(gatewayPublicId) {
    src_1.paypalState.gatewayPublicId = gatewayPublicId;
}
exports.setPaypalGatewayPublicId = setPaypalGatewayPublicId;
function getPaypalGatewayPublicId() {
    return src_1.paypalState.gatewayPublicId;
}
exports.getPaypalGatewayPublicId = getPaypalGatewayPublicId;
